module.exports = __webpack_public_path__ + "static/media/james-lee-F15yYq9aAsM-unsplash.58ccc8ce.jpg";